import React from "react";
import { Link } from "react-router-dom";

const CopyRightTwo = () => {
  return (
    <div className="bottom-footer-content">
      <div className="d-lg-flex align-items-center justify-content-center">
        <p> Copyright @{new Date().getFullYear()} Raidenlabs</p>
        <Link to='/privacy-policy'>
        <p className="px-md-2  me-2"> Privacy Policy </p>
        </Link>
        <Link to='/terms-and-conditions'>
        <p className=""> Terms and Conditions </p>
        </Link>
      </div>
    </div>
 
  );
};

export default CopyRightTwo;
